// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"773":"dac4869d","1145":"5ba8e627","1357":"5259dc64","3424":"f01ab32d","4526":"9bfe4c01","4814":"8b0787a8","6206":"5831e807","6241":"5c453f56","8992":"53edfbdb"}[chunkId] + ".chunk.css";
};